import React from 'react';
import { formatUSDT, timeAgo, getRandomNFTBg } from '../utils/helpers';
import './NFTCard.css';

const NFTCard = ({ nft, onSelect, isOwned = false }) => {
  // For owned NFTs, show purchase price; for market, show current price
  const displayPrice = isOwned ? nft.purchasePrice : nft.currentPrice;
  const price = parseFloat(formatUSDT(displayPrice));
  const tier = Math.ceil(price / 10);
  const nftBg = getRandomNFTBg(nft.nftId);
  
  return (
    <div 
      className={`nft-card ${isOwned ? 'owned' : ''}`}
      onClick={() => onSelect && onSelect(nft)}
    >
      <div className="nft-card-inner">
        {/* Visual with random GIF background */}
        <div className="nft-visual">
          <div className="nft-bg">
            <img src={nftBg} alt="" className="nft-bg-img" />
            <div className="nft-bg-overlay"></div>
          </div>
          <div className="nft-hexagon">
            <div className="hex-inner">
              <span className="hex-id font-numbers">#{nft.nftId}</span>
            </div>
            <div className="hex-glow"></div>
          </div>
          <div className="nft-particles">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="nft-particle" style={{ '--delay': `${i * 0.5}s` }}></span>
            ))}
          </div>
        </div>

        {/* Info */}
        <div className="nft-info">
          <div className="nft-name">
            <span className="name-text">ADNFT</span>
            <span className="name-id font-numbers">#{nft.nftId}</span>
          </div>
          <div className="nft-meta">
            <span className="meta-tier">Tier {tier}</span>
            {nft.lastPurchaseTime && (
              <span className="meta-time">{timeAgo(nft.lastPurchaseTime)}</span>
            )}
          </div>
        </div>

        {/* Price */}
        <div className="nft-footer">
          <div className="nft-price">
            <span className="price-label">{isOwned ? 'Bought At' : 'Price'}</span>
            <span className="price-value font-numbers">${formatUSDT(displayPrice)}</span>
          </div>
          {isOwned ? (
            <div className="nft-owned-badge">Owned</div>
          ) : (
            <button className="nft-buy-btn">Buy</button>
          )}
        </div>

        {/* Effects */}
        <div className="nft-shine"></div>
        <div className="nft-border"></div>
      </div>
    </div>
  );
};

export default NFTCard;
